module.exports = __webpack_public_path__ + "img/kr-red-card-right-bottom-1.378fa0c.png";